import { FC } from 'react';
import './WhatsNewFilterComponent.scss';
import { FilterVM } from '../../../../common/view-model';
import { isCurrentUserAnonymous } from '../../../../helpers/authenticationHelper';

interface IWhatsNewFilterComponentProps {
	filter: FilterVM;
	setCurrentCategory: (category?: string) => void;
	addFilter?: (filter: FilterVM) => void;
	handleTracking: (filter: FilterVM) => void;
	setLockModalContent: () => void;
	isMobile?: boolean;
	pendingFilters?: FilterVM[];
	setPendingFilters?: React.Dispatch<React.SetStateAction<FilterVM[]>>;
}

export const WhatsNewFilterComponent: FC<IWhatsNewFilterComponentProps> = ({
	filter,
	setCurrentCategory,
	addFilter,
	handleTracking,
	setLockModalContent,
	isMobile,
	pendingFilters,
	setPendingFilters
}) => {
	const handleClick = () => {
		if (isCurrentUserAnonymous()) {
			setLockModalContent();
			return;
		}
		handleTracking(filter);
		const { children, ...rest } = filter;
		const filterToApply: FilterVM = {
			...rest,
			isChecked: true,
			breadCrumbElements: [{ ...rest }],
			children: undefined
		};
		if (isMobile && setPendingFilters) {
			setPendingFilters(prev => {
				const filtered = prev.filter(f => f.id !== filter.id);
				return [...filtered, filterToApply];
			});
		} else {
			addFilter?.(filterToApply);
		}
		setCurrentCategory(filter?.name);
	};
	return (
		<div className='new-filter-container' onClick={handleClick}>
			<span className='filter-name'>{filter.name}</span>
			<i className='ri-arrow-right-s-line'></i>
		</div>
	);
};
